export default __webpack_public_path__ + "4fc537f6dd1fa34c9665f9288dbb5332.jpg";